// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___1Zaki","open":"open___1sZl0","page":"page___3cbdK"};